export enum ErpSyncFailureCategory {
    RutterRateLimitError = 'rutter-rate-limit-error',
    RutterUnsyncedLineItem = 'rutter-unsynced-line-item',
    RutterInvoiceAlreadyFullyPaid = 'rutter-invoice-already-fully-paid',
    XeroRateLimitOnAttachments = 'xero-rate-limit-on-attachments',
    RutterDuplicateExternalInvoiceIds = 'rutter-duplicate-external-invoice-ids',
    PortlessNonSucceededPayments = 'portless-non-succeeded-payments',
    CreditMemoNonSucceededPayments = 'credit-memo-non-succeeded-payments',
    NonSucceededPayments = 'non-succeeded-payments',
    Unknown = 'unknown',
}
